/**
* @file Fieldset component for color input
* @author Heino Lenting
*/
import * as tslib_1 from "tslib";
import { FieldsetBase } from '../../base/fieldsets/fieldset-base/fieldset-base';
import { FieldsetProvider } from '../../base/fieldsets/fieldset-provider';
import { ComponentRegistry } from '../../core/component-registry';
/**
 * Class for the color fieldset component
 */
var FieldsetColorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FieldsetColorComponent, _super);
    /**
     * Constructs a FieldsetColorComponent
     */
    function FieldsetColorComponent(provider) {
        return _super.call(this, provider) || this;
    }
    /**
     * Register component by the fieldset provider
     */
    FieldsetColorComponent.register = function () {
        ComponentRegistry.register('fieldset', 'color', FieldsetColorComponent);
    };
    FieldsetColorComponent.prototype.hasParent = function () {
        if (!this.provider.entity) {
            return false;
        }
        switch (this.provider.entity.entityType.shortName) {
            case 'Assignment':
            case 'Deployment':
            case 'Demand':
            case 'Attendant':
            case 'Service':
                return true;
        }
        return false;
    };
    return FieldsetColorComponent;
}(FieldsetBase));
export { FieldsetColorComponent };
